import './Sidebar.scss';

import classnames from 'classnames';
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { useEventListener } from '../../hooks/useEventListener';
import { isBrowserIE11 } from '../../utilities/lister-utilities';
import { isAcceptedRegion } from '../../utilities/locale-utilities';
import UpgradedFacetType from '../Facets/UpgradedFacets/FacetType';
import SidebarClearFiltersButton from './SidebarClearFiltersButton';
import SidebarHeading from './SidebarHeading';

const isNotIE11 = !isBrowserIE11();

export const Sidebar = () => {
	const { facets } = useSelector((state) => state);

	const ref = useRef();
	const sidebarRef = useRef();
	const clearStickyEvent = useRef();

	const [sticky, setSticky] = useState(false);
	const [currentPosition, setCurrentPosition] = useState(0);

	const handleScroll = () => {
		const currentRef = ref.current;

		if (!currentRef) {
			return;
		}

		const topPos = currentRef.getBoundingClientRect().top;

		const isSticky = topPos <= 16;

		setSticky(isSticky);

		if (isSticky) {
			clearStickyEvent.current();
		}
	};

	const handleSidebarScroll = () => {
		const { scrollHeight, offsetHeight, scrollTop } = sidebarRef.current;

		const scrollableHeight = scrollHeight - offsetHeight;
		const scrollPosition = scrollTop;
		const position = scrollPosition / scrollableHeight;
		setCurrentPosition(position);
	};

	clearStickyEvent.current = useEventListener(
		'scroll',
		handleScroll,
		window,
		isNotIE11
	);

	useEventListener(
		'scroll',
		handleSidebarScroll,
		sidebarRef.current,
		isNotIE11
	);

	if (!facets) {
		return null;
	}

	return (
		<aside
			ref={ref}
			className={classnames(
				'bg-white border border-solid border-gray-30 rounded-lg h-full w-1/3 lg:w-1/4',
				{
					'sidebar-sticky flex flex-col sticky': isNotIE11,
				}
			)}
			data-testid="sidebar"
			data-tag-section="lister sidebar">
			<div
				className={classnames(
					'p-4 lg:px-6 border-solid border-0 border-b border-gray-30 rounded-t-lg',
					{
						'z-0': isNotIE11,
						'sidebar-header--shadow': isNotIE11 && currentPosition > 0,
					}
				)}>
				<div
					className={classnames({
						'flex justify-between': isAcceptedRegion(['AOL'])
					})}>
					<SidebarHeading />

					<SidebarClearFiltersButton />
				</div>
			</div>

			<div
				ref={sidebarRef}
				className={classnames('lg:px-2', {
					'flex flex-col h-full pb-4': isNotIE11,
					'overflow-y-scroll': sticky && isNotIE11,
					'overflow-y-hidden': !sticky && isNotIE11,
				})}
				id="sidebarScroll">
				{facets.map((facet, index) => (
					<UpgradedFacetType
						facet={facet}
						key={facet.Id}
						position={index}
						isLastItem={index === facets.length - 1}
						largeLayoutScrollToTop
					/>
				))}
			</div>

			{isNotIE11 && (
				<div
					className={classnames('absolute bottom-0 w-full', {
						'sidebar-footer--shadow': sticky && currentPosition < 0.96,
						'sidebar-footer-shadow--animate': sticky && currentPosition > 0.96,
					})}
					style={{ height: '0px' }}></div>
			)}
		</aside>
	);
};

export default Sidebar;
